export const ensureInt = (n: number | string) => {
  return typeof n === 'string' ? parseInt(n, 10) : n
}

export const ensureFloat = (n: number | string) => {
  return typeof n === 'string' ? parseFloat(n) : n
}
